<template>
    <v-row v-if="value">
        <v-col>
            <v-card :disabled="!isCompany">
                <v-card-title class="subtitle-2 font-weight-bold">
                    상세정보2
                </v-card-title>
                <v-card-text>
                    <v-row class="mt-4">
                        <v-col cols="12" class="py-0">
                            <v-text-field label="기본소개" placeholder=" " hide-details v-model="value.meta.summary"></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row class="mt-4">
                        <v-col cols="12" class="py-0">
                            <v-row>
                                <v-col cols="12" class="py-0 caption">
                                    <span>상세소개</span>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" class="py-0 caption">
                                    <naver-smarteditor v-model="value.meta.introduction"></naver-smarteditor>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import NaverSmarteditor from "@/components/plugins/naver/naver-smarteditor.vue";
export default {
    components: { NaverSmarteditor },
    props: {
        value: Object,
    },
    computed: {
        isCompany() {
            return this.$store.state.payload._user == this.$route.params._user;
        },
    },
};
</script>

<style></style>
